import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { checkBoolean, isEmpty, isEmptyObject, prepareEchannelPayload, Translations } from '../../../../utils';
// constant
import { FORM_REFS, CASE_CANCELLED } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
//action Creator
import { hideActionButton } from '../../../layouts/actions/actionCreator';
import { updateCase } from '../../../createAcase/actions/actionCreator';
import { blockUi, unBlockUi } from '../../../../actions/actionCreator';
//style
import './styles.css';
import { setCaptureProductCashFlowForecasting } from '../../actions/actionCreator';


class CreateCashFlowForecastingEchannel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentProductCashFlowForecasting: {},
      eChannelType: { name: "", value: "" },
      formData: {}
    }
  }

  getTranslated = (value) => {
    return Translations(value, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  getEchannelReportingPageJson = () => {
    let apiURL = "/aemData/formData/json_create-echannel-reporting-page-cff";
    aemHostClient(apiURL)
      .then(({ data }) => {
        document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
        this.setState({ formJson: data });
      });
  }

  getCashFlowForecastingProductDetails = () => {
    if (!isEmpty(this.props.currentProductCashFlowForecasting)) {
      this.setState({ currentProductCashFlowForecasting: this.props.currentProductCashFlowForecasting })
    }
  }

  componentDidMount() {
    this.getEchannelReportingPageJson()
    this.getEChannelTypes()
    this.getCashFlowForecastingProductDetails()
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  getEChannelTypes = () => {
    taxonomyHostClient("/taxonomies/groups/echannel/type").then(response => {
      const { data } = response ? response : {}
      if (!isEmptyObject(data.responseData)) {
        const eChannelType = data.responseData.echannelTypeTaxonomy.classificationNodes.find(eChannelType => eChannelType.name == "HSBCnet")
        if (!isEmptyObject(eChannelType)) {
          this.setState({ eChannelType: { name: eChannelType.name, value: eChannelType.id } })
        }
      }
    })
  }

  onFormSubmit = (event, apiUrl) => {
    if (!isEmptyObject(this.state.currentProductCashFlowForecasting.data)) {
      const { caseId } = this.state.currentProductCashFlowForecasting.data

      this.props.blockUi();

      const requestData = prepareEchannelPayload({ ...this.state.formData }, caseId);
      eapiClient(apiUrl, {
        method: 'POST',
        data: JSON.stringify(requestData)
      })
        .then(({ data }) => {
          const { id } = data.responseData;
          this.props.setCaptureProductCashFlowForecasting({ selectedEChannelId: id });
          this.props.history.goBack();
          this.props.unBlockUi();
        });
    }
  }

  onFormCancel = () => {
    if (!checkBoolean(this.props.currentProductCashFlowForecasting.eChannelReportingDetails.reportToEChannel)) {
      this.props.setCaptureProductCashFlowForecasting({ eChannelReportingDetails: { ...this.props.currentProductCashFlowForecasting.eChannelReportingDetails, reportToEChannel: true } });
    }
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData = {}
    let properties = {}
    if (!isEmptyObject(this.state.currentProductCashFlowForecasting.data)) {
      const { cffAgent, caseId, country } = this.state.currentProductCashFlowForecasting.data
      formData = { newEchannel: false, profileOwnerInPack: cffAgent, country: country, other: false, eChannelType: this.state.eChannelType, profileOwner: true };

      properties = {
        echannelId: "",
        caseId: caseId,
        formData,
        existingEntityData: [cffAgent],
        editType: 'add-existing-echannel-to-case',
        pathname: this.props.history.location.pathname
      };
    }
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_editEchannelForm !== undefined) {
      return (
        <Dynamicform mode="edit"
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_editEchannelForm.formRef]}
          getFormData={this.getFormData}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
          productType={"add-create-cash-flow-forecasting-echannel"}
          formTouched={true}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : '';
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">
            {Translations(pageTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </h2>
          <p className="form-required-desc">
            {Translations(pageTitle.descriptionText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </p>
        </div>
        {this.renderFormGroups()}
      </div>
    );
  }
}


const mapStateToProps = (state, props) => {
  return {
    cases: state.cases,
    lang: state.lang,
    currentProductCashFlowForecasting: state.currentProductCashFlowForecasting
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    updateCase: (caseId, productType, productData) => {
      dispatch(updateCase(caseId, productType, productData))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
    setCaptureProductCashFlowForecasting: data => {
      dispatch(setCaptureProductCashFlowForecasting(data));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCashFlowForecastingEchannel);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductCashFlowForecasting/CreateCashFlowForecastingEchannel.js